'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SmallPublic = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsxs("g", {
                    clipPath: "url(#clip0_4803_12688)",
                    children: [
                        jsxRuntime.jsx("path", {
                            d: "M5.20996 7.68004C5.33996 9.16004 5.79996 10.83 6.88996 12.6C6.88996 12.6 6.92996 12.67 6.98996 12.76C7.06996 12.64 7.10996 12.56 7.10996 12.56C8.17996 10.8 8.64996 9.15004 8.77996 7.67004H5.20996V7.68004Z",
                            fill: "currentColor"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M8.41002 0.600024C8.41002 0.600024 10.02 2.90002 10.19 6.26002H13.65C13.51 4.71002 12.86 3.29002 11.76 2.20002C10.8 1.24002 9.59002 0.630024 8.27002 0.400024C8.35002 0.510024 8.41002 0.590024 8.42002 0.600024H8.41002Z",
                            fill: "currentColor"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M7.26993 1.42C7.26993 1.42 7.15993 1.27 7.00993 1.06C6.83993 1.3 6.71993 1.46 6.71993 1.46C6.62993 1.58 5.33993 3.46 5.17993 6.27H8.80993C8.65993 3.42 7.35993 1.54 7.26993 1.41V1.42Z",
                            fill: "currentColor"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M5.69005 13.3201C4.46005 11.3001 3.95005 9.39005 3.83005 7.68005H0.300049C0.430049 9.24005 1.09005 10.6701 2.19005 11.7701C3.20005 12.7801 4.48005 13.4001 5.87005 13.6101C5.77005 13.4501 5.70005 13.3401 5.69005 13.3301V13.3201Z",
                            fill: "currentColor"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M10.1601 7.66002C10.0401 9.36002 9.53013 11.27 8.30013 13.28C8.30013 13.29 8.23013 13.4 8.13013 13.56C11.0101 13 13.2701 10.6 13.6201 7.65002H10.1601V7.66002Z",
                            fill: "currentColor"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M3.81008 6.28005C3.98008 2.93005 5.56008 0.680054 5.59008 0.650054C5.59008 0.640054 5.66008 0.560054 5.75008 0.430054C2.91008 1.01005 0.690078 3.38005 0.330078 6.29005H3.81008V6.28005Z",
                            fill: "currentColor"
                        })
                    ]
                }),
                jsxRuntime.jsx("defs", {
                    children: jsxRuntime.jsx("clipPath", {
                        id: "clip0_4803_12688",
                        children: jsxRuntime.jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsxs("g", {
                    clipPath: "url(#clip0_4830_8528)",
                    children: [
                        jsxRuntime.jsx("path", {
                            d: "M7.06857 1.00033C3.75161 1.03461 1.03461 3.75161 1.00033 7.06857C0.966045 10.3855 3.61447 13.034 6.93143 12.9997C10.2484 12.9654 12.9568 10.2484 12.9997 6.93143C13.034 3.61447 10.3855 0.966045 7.06857 1.00033Z",
                            stroke: "currentColor",
                            strokeWidth: "1.4"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M1.00037 7.06853L12.9997 6.9314",
                            stroke: "currentColor",
                            strokeWidth: "1.4"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M6.17722 1.06891C6.17722 1.06891 2.31172 6.42576 6.31436 12.974",
                            stroke: "currentColor",
                            strokeWidth: "1.4"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M7.95132 1.05176C7.95132 1.05176 11.6968 6.3229 7.53992 12.9654",
                            stroke: "currentColor",
                            strokeWidth: "1.4"
                        })
                    ]
                }),
                jsxRuntime.jsx("defs", {
                    children: jsxRuntime.jsx("clipPath", {
                        id: "clip0_4830_8528",
                        children: jsxRuntime.jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

module.exports = SmallPublic;
